import { GlobalState } from '../../reducers';
import { MobileAppSelectionState } from './reducers';

const mobileAppSelectionSelector = (store: GlobalState): MobileAppSelectionState => (
  store.apps.manual.mobileAppSelection
);

export default {
  mobileAppSelectionSelector,
};
